import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import NadheoPerformanceStatus from './NadheoPerformanceStatus'
import PerformanceCache from './util/PerformanceCache'

export default function NadheoEmbeddedStatus(props) {
  let {show, place, startTime} = props;

  const [performance, setPerformance] = useState();

  useEffect(()=>{
    PerformanceCache.retrievePerformance({"show.name": show, "place.name": place, "start.time": startTime})
      .then((performance)=> {
        setPerformance(performance);
      })
      .catch((e)=> {
        console.log(e);
      })
  }, [show, place, startTime]);

  return (
    <PerformanceStatus performance={performance}/>
  );
}

function PerformanceStatus(props) {
  const { t } = useTranslation(["booking", "common"]);
  const {performance } = props;
  if (performance === undefined) return t("common:Chargement en cours");
  if (performance.status === "not published") return "";
  let closingDate = performance["closing.date"];
  let openingDate = performance["opening.date"];
  let remainingFreeSeats = performance["available.seat.nbr"];
  return (
    <NadheoPerformanceStatus timezone={performance.timezone}
                             status={performance.status}
                             closing_date={closingDate}
                             opening_date={openingDate}
                             free_seats={remainingFreeSeats}/>
  );
}